<app-performance-tab [storageKey]="storageKey" [loadStats]="loadStats">
    <ng-template let-stats let-sidenav="sidenav">
        @if (stats.meta.results) {
            <app-promotion-type-stats
                [data]="stats.data"></app-promotion-type-stats>
        } @else {
            <app-empty-state
                illustration="search"
                title="No Statistics Yet"
                message="There is no data in the selected date range and filters.">
                <a
                    class="btn-secondary"
                    (click)="sidenav.open(); $event.stopPropagation()">
                    Edit Filters
                </a>
            </app-empty-state>
        }
    </ng-template>
</app-performance-tab>
